import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SHOW_GLOBAL_LOADER } from '@shared/data-access/data-access-ui';
import { isDefined } from '@shared/utils/is-defined.utils';
import { Observable } from 'rxjs';

import { OrganizationAdmin } from '../../../user/data-access-users/model/organization-admin.model';
import { CreateSuborganizationRequest } from '../model/create-suborganization-request.model';
import { FilterSuborganizationRequest } from '../model/filter-suborganization-request.model';
import { SuborganizationUser } from '../model/suborganization-user.model';
import { UpdateSuborganizationRequest } from '../model/update-suborganization-request.model';

@Injectable()
export class SuborganizationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  createSuborganization(payload: CreateSuborganizationRequest): Observable<OrganizationAdmin> {
    return this.http.post<OrganizationAdmin>(`${this.baseUrl}/v1/organizations`, payload, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }

  updateSuborganization(id: string, payload: UpdateSuborganizationRequest): Observable<OrganizationAdmin> {
    return this.http.patch<OrganizationAdmin>(`${this.baseUrl}/v1/organizations/${id}`, payload, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }

  deleteSuborganization(id: string): Observable<number> {
    return this.http.delete<number>(`${this.baseUrl}/v1/organizations/${id}`, {
      context: new HttpContext().set(SHOW_GLOBAL_LOADER, true),
    });
  }

  getSuborganizationUsers(subOrganizationId: string): Observable<SuborganizationUser[]> {
    return this.http.get<SuborganizationUser[]>(
      `${this.baseUrl}/v1/organizations/suborganizations/${subOrganizationId}/users`,
      { context: new HttpContext().set(SHOW_GLOBAL_LOADER, false) },
    );
  }

  getSuborganizations(payload: FilterSuborganizationRequest): Observable<OrganizationAdmin[]> {
    let params = new HttpParams();

    if (payload.ordering) {
      params = params.set('ordering', payload.ordering);
    }

    if (payload.sortDirection) {
      params = params.set('sortDirection', payload.sortDirection);
    }

    if (isDefined(payload.pageNumber)) {
      params = params.set('pageNumber', payload.pageNumber);
    }

    if (payload.pageSize) {
      params = params.set('pageSize', payload.pageSize);
    }

    return this.http.get<OrganizationAdmin[]>(
      `${this.baseUrl}/v1/organizations/${payload.organizationId}/suborganizations`,
      {
        params,
        context: new HttpContext().set(SHOW_GLOBAL_LOADER, payload.enableGlobalLoader),
      },
    );
  }
}
